import React from "react";
import styled from "@emotion/styled";
import backgroundImage from "assets/img/landing/background.svg";
import {ReactComponent as GameLogo} from "assets/img/game_logo.svg";
import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import {ISecretGateController} from "views/controllers/secret_gate/secret_gate.controller";
import {observer} from "mobx-react";

const Wrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	flex-direction: column;
	width: 100%;
	overflow: hidden;
	background: url("${backgroundImage}");
	background-size: auto 100%;
	max-height: 100vh;
	gap: 160px;
	height: 100vh;
	min-height: 100vh;
	max-height: -webkit-fill-available;
`;

const LogoWrapper = styled.div`
	margin-top: 60px;
	max-width: 190px;
	svg {
		height: auto;
		width: 100%;
	}
`;

const ComingSoonCopy = styled.div`
	color: #fff;

	text-align: center;
	font-size: 36px;
	font-style: normal;
	font-weight: 700;
	line-height: 150%; /* 54px */
	text-transform: capitalize;
`;

export const ComingSoonPage: React.FC = observer(() => {
	const controller = useViewController<ISecretGateController>(Bindings.SecretGateController);
	return (
		<Wrapper>
			<LogoWrapper>
				<GameLogo />
			</LogoWrapper>
			<ComingSoonCopy>
				{/*eslint-disable-next-line */}
				Coming <span onClick={controller.handleSecretClick}>soon</span>...
			</ComingSoonCopy>
		</Wrapper>
	);
});

export default ComingSoonPage;
